import { render, staticRenderFns } from "./headerdate.vue?vue&type=template&id=343b131c&scoped=true&"
import script from "./headerdate.vue?vue&type=script&lang=js&"
export * from "./headerdate.vue?vue&type=script&lang=js&"
import style0 from "./headerdate.vue?vue&type=style&index=0&id=343b131c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343b131c",
  null
  
)

export default component.exports